export function deepEqual(a: any, b: any, visited = new WeakMap()): boolean {
  if (a === b) return true;

  if (typeof a !== typeof b) return false;

  if (a === null || b === null) return a === b;

  // Handle Dates
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  // Handle arrays
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i], visited)) return false;
    }
    return true;
  }

  // Handle plain objects (excluding arrays, dates, etc.)
  if (typeof a === 'object' && typeof b === 'object') {
    if (visited.get(a) === b) return true; // Handle cyclic references
    visited.set(a, b);

    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;
    for (const key of aKeys) {
      if (!bKeys.includes(key) || !deepEqual(a[key], b[key], visited)) {
        return false;
      }
    }
    return true;
  }

  // Fallback for everything else (functions, etc.)
  return false;
}
